import React from "react";
import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CircleFAButton from "components/CircleFAButton";
import Image from "components/Image";
import "./SkillItem.scss";
import styled from "styled-components";

const ServiceItem = ({
  iconName,
  imageFileName,
  header,
  content,
  wording,
  imageMainSkills,
  altImageMainSkills,
  imageOtherSkills,
  altImageOtherSkills,
}) => {
  console.log("imageMainSkills", imageMainSkills);
  console.log("imageOtherSkills", imageOtherSkills);
  let iconPart;
  if (iconName) {
    iconPart = <CircleFAButton iconName={iconName} />;
  }

  const renderImageSkill = ({ path, index, alts }) => {
    const key = `${index}${path}`;
    const pacement = "bottom";
    return (
      <OverlayTrigger key={key} placement={pacement} overlay={<Tooltip>{alts[index]}</Tooltip>}>
        <WrapperImage>
          <Image alt={alts[index]} className="service-item-image" fileName={path} />
        </WrapperImage>
      </OverlayTrigger>
    );
  };

  const { wordingMainSkill, wordingOtherSkill } = wording;
  return (
    <Container>
      <h4 className="">{header}</h4>
      <Text className="">{content}</Text>
      <ContainerSkill>
        <WrapperSkill>
          <Text className="">{`${wordingMainSkill}: `}</Text>
          <RowImage>
            {imageMainSkills.map((path, index) =>
              renderImageSkill({ path, index, alts: altImageMainSkills }),
            )}
          </RowImage>
        </WrapperSkill>

        <WrapperSkill>
          <Text className="">{`${wordingOtherSkill}: `}</Text>
          <RowImage>
            {imageOtherSkills.map((path, index) =>
              renderImageSkill({ path, index, alts: altImageOtherSkills }),
            )}
          </RowImage>
        </WrapperSkill>
      </ContainerSkill>
    </Container>
  );
};

ServiceItem.propTypes = {
  iconName: PropTypes.string,
  imageFileName: PropTypes.string,
  header: PropTypes.string,
  content: PropTypes.string,
  imageMainSkills: PropTypes.array,
  altImageMainSkills: PropTypes.array,
  imageOtherSkills: PropTypes.array,
  altImageOtherSkills: PropTypes.array,
  wording: PropTypes.object,
};

ServiceItem.defaultProps = {
  iconName: null,
  imageFileName: null,
  header: "",
  content: "",
  imageMainSkills: [],
  altImageMainSkills: [],
  imageOtherSkills: [],
  altImageOtherSkills: [],
  wording: {
    wordingMainSkill: "Main skill",
    wordingOtherSkill: "Other skill",
  },
};

export default ServiceItem;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  background: #fff;
  width: 100%;
  border-radius: 0.6em;
  margin: 1rem 0;
  padding: 1em;
  overflow: hidden;
  box-shadow: 0 3px 6px #ddd;
  transition: all ease 200ms;

  /* border: 1px solid #e6e6e6; */
`;

const Text = styled.p`
  text-align: left;
  margin-bottom: 5px;
  margin-top: 10px;
`;

const ContainerSkill = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
`;

const WrapperSkill = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const WrapperImage = styled.div`
  display: flex;
  border-radius: 10px;
  padding: 4px;
  margin-right: 5px;
  width: 50px;
  height: 50px;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 6px #ddd;
`;

const RowImage = styled.div`
  display: flex;
  flex-direction: row;
`;
